import React, { useState, useEffect } from 'react';
import { searchBusinesses } from '../services/api';
import './BusinessExplorer.css';

function BusinessExplorer({ community, currentBusiness, onBusinessSelect }) {
  const [businesses, setBusinesses] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    if (community) {
      loadBusinesses();
    }
  }, [community]);

  const loadBusinesses = async () => {
    setIsLoading(true);
    try {
      const response = await searchBusinesses('');
      setBusinesses(response.results || []);
      
      // Extract categories
      const cats = [...new Set(response.results?.map(b => b.category || b.type).filter(Boolean))];
      setCategories(cats);
    } catch (error) {
      console.error('Failed to load businesses:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      loadBusinesses();
      return;
    }

    setIsLoading(true);
    try {
      const response = await searchBusinesses(query);
      setBusinesses(response.results || []);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const filteredBusinesses = businesses.filter(business => {
    if (!searchQuery) return true;
    return business.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
           business.category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
           business.type?.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div className="business-explorer">
      <div className="explorer-header">
        <h3>Local Businesses</h3>
        <div className="search-box">
          <input
            type="text"
            placeholder="Search businesses..."
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>

      {categories.length > 0 && (
        <div className="category-filters">
          <button 
            className={!searchQuery ? 'active' : ''}
            onClick={() => handleSearch('')}
          >
            All
          </button>
          {categories.map(category => (
            <button
              key={category}
              className={searchQuery === category ? 'active' : ''}
              onClick={() => handleSearch(category)}
            >
              {category}
            </button>
          ))}
        </div>
      )}

      <div className="business-list">
        {isLoading ? (
          <div className="loading">Loading businesses...</div>
        ) : filteredBusinesses.length > 0 ? (
          filteredBusinesses.map(business => (
            <div
              key={business.slug}
              className={`business-item ${currentBusiness?.slug === business.slug ? 'active' : ''}`}
              onClick={() => onBusinessSelect(business)}
            >
              <h4>{business.name}</h4>
              <p className="business-type">{business.category || business.type}</p>
              {business.rating && (
                <div className="rating">
                  {'★'.repeat(Math.floor(business.rating))} ({business.rating})
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="no-results">
            {searchQuery ? 'No businesses found' : 'No businesses available'}
          </div>
        )}
      </div>
    </div>
  );
}

export default BusinessExplorer;